import styled from 'styled-components';
import { Headline800Skin } from '../../../atoms/Headline/HeadlineSkins';
import { CopyBigSkin } from '../../../atoms/Copytext/CopytextSkins';
import { mq } from '~/styles/grid';
import { useIntl } from 'react-intl';

const StyledCountdown = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  @media (${(props) => props.theme.eventCounter.mobileSwitch}) {
    flex-direction: column;
    align-items: center;
    width: 100%;
    justify-content: center;
    padding: 20px 25px 0 30px;
  }
`;

const Segment = styled.div`
  display: inline-flex;
  flex-direction: column;
  padding: 0 30px;
  border-right: 1px solid rgba(255, 255, 255, 0.25);

  &:last-child {
    border: none;
  }

  @media (${mq.md}) {
    padding: 0 20px;
  }

  @media (${(props) => props.theme.eventCounter.mobileSwitch}) {
    width: 60%;
    border-right: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.25);
    flex-direction: row;
    align-items: baseline;
    justify-content: center;
    padding: 5px 0;
  }
  @media (${mq.sm}) {
    width: 100%;
  }
  @media (${mq.xs}) {
    width: 80%;
  }
`;

const Value = styled.span`
  ${Headline800Skin};
  display: inline;
  text-align: right;
  color: ${(props) => props.theme.color.white500};
  @media (${(props) => props.theme.eventCounter.mobileSwitch}) {
    padding: 0 15px 0 0;
    width: 50%;
  }
`;

const Unit = styled.span`
  ${CopyBigSkin};
  margin-top: 0px;
  display: inline-flex;
  align-self: flex-end;
  color: ${(props) => props.theme.color.white500};
  @media (${(props) => props.theme.eventCounter.mobileSwitch}) {
    width: 50%;
    align-self: baseline;
  }
`;

/**
 * @param {DurationType} props
 * @returns {React.ReactElement} The rendered component
 */
const Countdown = ({ days, hours, minutes, seconds }) => {
  const intl = useIntl();
  return (
    <StyledCountdown>
      {days > 0 && (
        <Segment>
          <Value>{days}</Value>
          <Unit>
            {intl.formatMessage({ id: 'datetime.days' }, { numDays: days })}
          </Unit>
        </Segment>
      )}
      {(days > 0 || hours > 0) && (
        <Segment>
          <Value>{hours}</Value>
          <Unit>
            {intl.formatMessage({ id: 'datetime.hours' }, { numHours: hours })}
          </Unit>
        </Segment>
      )}
      {(days > 0 || hours > 0 || minutes > 0) && (
        <Segment>
          <Value>{minutes}</Value>
          <Unit>
            {intl.formatMessage(
              { id: 'datetime.minutes' },
              { numMinutes: minutes },
            )}
          </Unit>
        </Segment>
      )}
      <Segment>
        <Value>{seconds}</Value>
        <Unit>
          {intl.formatMessage(
            { id: 'datetime.seconds' },
            { numSeconds: seconds },
          )}
        </Unit>
      </Segment>
    </StyledCountdown>
  );
};

export default Countdown;
